import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {CommonUtils} from "../../utils/common";
import {UserService} from "../../providers/user.service";
import {ModalController} from "@ionic/angular";
import {AppStateService} from "../../providers/app-state.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-reset-pwd',
  templateUrl: './reset-pwd.component.html',
  styleUrls: ['./reset-pwd.component.scss'],
})
export class ResetPwdComponent implements OnInit, OnDestroy {
  resetPwdGroup: FormGroup;
  isBusy: boolean;
  isBusySub: Subscription;
  resetPwddSub: Subscription;


  constructor(public commonUtils : CommonUtils,
              private formBuilder: FormBuilder,
              private userService: UserService,
              private appStateService: AppStateService,
              private modalController: ModalController) {
  }

  ngOnInit() {
    this.isBusySub = this.appStateService.isBusySubject.subscribe(e => this.isBusy = e);
    this.resetPwdGroup = this.formBuilder.group({
      mail: ['', [Validators.required, Validators.email]],
    });
  }

  onReset() {
    this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zresetować hasło?', 'Tak', 'Nie', 'checkmark', 'close', () => {
      this.appStateService.updateIsBusySubject(true);
      let value = this.resetPwdGroup.controls['mail'].value;

      this.resetPwddSub = this.userService.restoreMyPassword(value)
        .subscribe(e => {
            this.appStateService.updateIsBusySubject(false);
            this.modalController.dismiss();
          },
          error => {
            this.appStateService.updateIsBusySubject(false);
            this.modalController.dismiss()

          });
    }, () => {
      this.appStateService.updateIsBusySubject(false);
    });
  }

  onCancelReset() {
    this.modalController.dismiss();
  }

  isFormFieldInvalid(resetPwdGroup: any, type: string, validationType: string) {
    return this.commonUtils.isFormFieldInvalid(resetPwdGroup, type, validationType);
  }

  ngOnDestroy(): void {
    if (this.resetPwddSub) {
      this.resetPwddSub.unsubscribe();
    }
    if (this.isBusySub) {
      this.isBusySub.unsubscribe();
    }
  }

}
